export default __webpack_public_path__ + "static/media/logo.80a82043.png";